import PersonalBooking from "./PersonalBooking";

export default PersonalBooking;